import { Avatar, AvatarSize, Box, Text } from '@bechtel/gds';
import { concat } from 'lodash';
import { FC } from 'react';
import { useDate } from '~/hooks';
import { AvatarPlaceholderStyled, AvatarSectionStyled } from './styled';
import { UserInfoProps } from './types';

export const UserInfo: FC<UserInfoProps> = ({ userAccount, updatedTime, updatedBy }) => {
  const { formatLocaleDate, formatLocaleTime } = useDate();
  return (
    <Box py={{ sm: '400' }}>
      <AvatarSectionStyled>
        {userAccount ? (
          userAccount.userAccountPhoto?.photo ? (
            <Avatar size={AvatarSize.SMALL} src={userAccount?.userAccountPhoto?.photo}></Avatar>
          ) : (
            <AvatarPlaceholderStyled>
              <Text size="200">
                {userAccount?.nameFirst?.slice(0, 1)}
                {userAccount?.nameLast?.slice(0, 1)}
              </Text>
            </AvatarPlaceholderStyled>
          )
        ) : (
          <Avatar size={AvatarSize.SMALL}></Avatar>
        )}
      </AvatarSectionStyled>
      <Box
        alignItems={{ sm: 'center' }}
        justifyContent={{ sm: 'space-between' }}
        flexGrow={{ sm: 1 }}
        ml={{ sm: '200' }}
      >
        <Box flexDirection={{ sm: 'column' }} style={{ overflow: 'hidden' }}>
          <Text size="300" weight="600" style={{ textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
            {userAccount ? concat(userAccount?.nameFirst, ' ', userAccount?.nameLast) : updatedBy}
          </Text>
          {updatedTime && (
            <Box pt={{ sm: '200' }}>
              <Text size="200" color="grey.600" weight="400" family="openSansCondensed">
                {`${formatLocaleDate(updatedTime)} ${formatLocaleTime(updatedTime)}`}
              </Text>
            </Box>
          )}
        </Box>
      </Box>
    </Box>
  );
};
